import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PromoBanner } from "@similarweb/ui-components";

export const DunningsBanner = styled(PromoBanner)<{ isLastPaymentFailedWarning?: boolean }>`
    background: ${({ isLastPaymentFailedWarning }) =>
        isLastPaymentFailedWarning ? colorsPalettes.red[100] : colorsPalettes.yellow[200]};
    padding: 16px 24px;
`;
export const DunningsBannerImage = styled.img`
    width: 56px;
    height: 56px;
`;
